import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationSettings, ApplicationSettingService, UtilityService } from 'tms-lib';

/** The longest Months to Analyse period, and the top of the range StockForecastDefaultMonths must fall in. */
export const maximumMonthsToAnalyse = 12;

/**
 * The StockForecastDefaultMonths setting and the Months to Analyse options, shared by the
 * product's Stock Forecasting tab and Analysis → Stock Forecasting.
 */
@Injectable({
  providedIn: 'root',
})
export class StockForecastDefaultService {
  private readonly applicationSettingService = inject(ApplicationSettingService);
  private readonly utilityService = inject(UtilityService);

  /** The periods 1 to 12, after 0 when `includeNone` (Analysis offers 0). */
  monthsToAnalyseOptions(includeNone = false) {
    const months = Array.from({ length: maximumMonthsToAnalyse }, (_, index: number) => index + 1);
    return this.utilityService.mapToSelectOptions(includeNone ? [0, ...months] : months);
  }

  /**
   * The period to pre-select, or undefined when the setting is blank, 0, out of range or not a
   * whole number (getNumber returns 0 for text), which leaves the screen as it always was.
   *
   * It is the option's STRING id, typed as the model's number: the options carry string ids
   * (mapToSelectOptions) and ng-select matches the model with ===, so a number would load the
   * figures and leave the dropdown showing nothing selected.
   */
  defaultMonthsToAnalyse(): Observable<number | undefined> {
    return this.applicationSettingService
      .getNumber(ApplicationSettings.stockForecastDefaultMonths)
      .pipe(
        map((months: number) =>
          Number.isInteger(months) && months >= 1 && months <= maximumMonthsToAnalyse
            ? (months.toString() as unknown as number)
            : undefined,
        ),
      );
  }
}
